export function convertImageToWebp(file, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        if (blob) {
          const base = (file && typeof file.name === 'string')
            ? file.name.replace(/\.[^.]+$/, '')
            : 'image';
          const webpFile = new File([blob], `${base}.webp`, { type: 'image/webp' });
          resolve(webpFile);
        } else {
          reject(new Error('Failed to convert image to WebP.'));
        }
      }, 'image/webp', quality);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}
